import { render, staticRenderFns } from "./HouseholdMonthlyIncome.vue?vue&type=template&id=68638346&scoped=true&"
import script from "./HouseholdMonthlyIncome.vue?vue&type=script&lang=js&"
export * from "./HouseholdMonthlyIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68638346",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68638346')) {
      api.createRecord('68638346', component.options)
    } else {
      api.reload('68638346', component.options)
    }
    module.hot.accept("./HouseholdMonthlyIncome.vue?vue&type=template&id=68638346&scoped=true&", function () {
      api.rerender('68638346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/HouseholdMonthlyIncome.vue"
export default component.exports